angular.module('leanlaw').controller('QuickbooksImportCtrl', ['$scope', '$q', 'accountingService', 'clientMatterManager', 'leanLawApi', '$state', 'userService', 'alerts', 'tracking', function ($scope, $q, accountingService, clientMatterManager, leanLawApi, $state, userService, alerts, tracking) {
  $scope.data = {
    clients: []
  };
  activate();
  $scope.filter = function (filter) {
    $scope.data.filter = filter;
  };
  $scope.selectAll = function (select) {
    _.each($scope.data.filteredClients, client => {
      client.selected = select && !client.client;
      selectClient(client);
    });
  };
  $scope.selectClient = function (client) {
    if (!client.selected && !_.find(client.filteredMatters, m => !m.selected) && !client.matterName) {
      // This allows the user to click a second time and deselect matters but keep client selected
      selectClient(client);
      client.selected = true;
    } else {
      selectClient(client);
    }
  };
  function selectClient(client) {
    _.each(client.filteredMatters, matter => {
      matter.selected = client.selected && !matter.matter;
    });
    if (!client.clients && !client.client) {
      client.matterName = client.selected ? client.name : null;
    }
    client.matterSelected = !!_.find(client.filteredMatters, m => m.selected);
  }
  $scope.selectMatter = function (client, matter) {
    client.matterSelected = !!_.find(client.filteredMatters, c => c.selected);
    client.selected = client.matterSelected && !client.client;
  };
  $scope.connectClient = function (client) {
    $state.go('.edit', {
      client
    });
  };
  $scope.connectMatter = function (client, matter) {
    $state.go('.edit', {
      client,
      matter
    });
  };
  function human(n, noun) {
    if (n == 1) return `one ${noun}`;
    return `${n || "no"} ${noun}s`;
  }
  $scope.import = importClients;

  //////////////////////////

  function activate() {
    userService.list().then(users => {
      $scope.users = users;
    });
    $scope.loading = true;
    userService.me().then(me => {
      $scope.me = me;
      $scope.defaultResponsible = me;
      $scope.billClient = (me.company.settings.clientBilling || {}).billClient;
      accountingService.verify(true).then(() => {
        accountingService.getImportableClients().then(accountingClients => {
          $scope.loading = false;
          $scope.data.clients = accountingClients;
          clientMatterManager.listClients({
            scope: 'all',
            include: 'matters'
          }).then(clients => {
            _.each(clients, client => {
              const existing = accountingClients.find(c => c.client && c.client.id == client.id);
              if (existing) {
                // Fill in more detail for clients we know about
                existing.client.billClient = client.billing.billClient;
              }
              const candidate = _.find(accountingClients, c => !c.client && c.name == client.name);
              if (candidate) {
                candidate.candidate = client;
                _.each(client.matters, matter => {
                  const candidateMatter = _.find(candidate.clients, m => !m.matter && m.name == matter.name);
                  if (candidateMatter) {
                    candidateMatter.candidate = matter;
                  }
                });
              }
            });
            accountingClients.forEach(client => {
              client.billClient = $scope.billClient && (!client.clients || !client.clients.length);
              if (client.client) {
                client.billClient = client.client.billClient;
              }
            });
          });
        });
      }).catch(() => {
        $state.go('^');
      });
    });
  }
  function importClients() {
    alerts.dismiss();
    const clients = _.reduce($scope.data.filteredClients, (sum, c) => sum + (c.selected ? 1 : 0), 0);
    const matters = _.reduce($scope.data.filteredClients, (sum, c) => sum + _.reduce(c.clients, (sum, m) => sum + (m.selected ? 1 : 0), 0) || (c.matterName ? 1 : 0), 0);
    if (clients + matters == 0) {
      alerts.warning(`Please select some clients and ${$scope.me.terms.matter}s to import first`);
      return;
    }
    const prompt = `<p>Are you sure you want to create clients and ${$scope.me.terms.matter}s for all the selected QuickBooks clients?</p><p>It's ${human(clients, " client")} and ${human(matters, $scope.me.terms.matter)}.`;
    bootbox.confirm(prompt, ok => {
      if (ok) {
        processClients();
      }
    });
  }
  function processClients() {
    $scope.importing = true;
    let process = $q.resolve();
    _.each($scope.data.clients, client => {
      if (!client.matterSelected && !client.selected) return;
      process = process.then(() => processClient(client).then(processed => {
        client.process = {
          done: true
        };
        client.selected = false;
        return processed;
      }).catch(err => {
        console.log(err);
        client.process = {
          error: err.body.message
        };
      }));
    });
    process.then(results => {
      // Segment tracking: completed client/matter import from QBO
      if (tracking) {
        tracking.event('Client Matter Imported From QBO', null, {});
      }
      alerts.success("Done importing, please check your list for any errors");
      accountingService.refresh();
      clientMatterManager.refresh();
      $scope.importing = false;
    });
  }
  function processClient(client) {
    return createOrGetOrConnect(client).then(createdClient => {
      client.client = createdClient;
      const matters = _.filter(client.filteredMatters, m => m.selected);
      if (matters.length == 0 && client.matterName) {
        // The backend will create the QBO subcustomer for us, if necessary
        return leanLawApi.createMatter({
          body: {
            name: client.matterName,
            client: {
              id: createdClient.id
            },
            users: [{
              id: client.responsible ? client.responsible.id : $scope.defaultResponsible.id,
              role: 'primary'
            }],
            method: 'QBO Import'
          }
        });
      }
      let process = $q.resolve();
      _.each(matters, matter => {
        process = process.then(() => {
          matter.process = {
            processing: true
          };
          return createOrUpdateMatter(createdClient, matter).then(updateMatter => {
            matter.matter = updateMatter;
            matter.selected = false;
            matter.process = {
              done: true
            };
          });
        });
      });
      return process;
    });
  }
  function createOrUpdateMatter(createdClient, matter) {
    const billClient = createdClient.billing ? createdClient.billing.billClient : createdClient.billClient;
    if (billClient) {
      if (matter.candidate) $q.resolve();
      var matterCreate = {
        client: {
          id: createdClient.id
        },
        name: matter.name,
        method: 'QBO Import',
        users: [{
          id: matter.responsible ? matter.responsible.id : $scope.defaultResponsible.id,
          role: 'primary'
        }]
      };
      return leanLawApi.createMatter({
        body: matterCreate
      });
    }
    if (matter.candidate) {
      return leanLawApi.updateMatterAccounting({
        id: matter.existing.id,
        body: {
          accounting: {
            id: matter.id,
            name: matter.name
          }
        }
      });
    }
    var matterCreate = {
      client: {
        id: createdClient.id
      },
      name: matter.name,
      accounting: {
        id: matter.id,
        name: matter.name
      },
      users: [{
        id: matter.responsible ? matter.responsible.id : $scope.defaultResponsible.id,
        role: 'primary'
      }],
      method: 'QBO Import'
    };
    return leanLawApi.createMatter({
      body: matterCreate
    });
  }
  function createOrGetOrConnect(client) {
    if (client.candidate) {
      client.process = {
        processing: true
      };
      return leanLawApi.updateClientAccounting({
        id: client.candidate.id,
        body: {
          accounting: {
            id: client.id,
            name: client.name
          }
        }
      }).then(updated => {
        client.candidate = null;
        return updated;
      });
    }
    if (client.selected) {
      const clientCreate = {
        contact: client.contact,
        method: 'QBO Import'
      };
      clientCreate.accounting = {
        id: client.id,
        name: client.name
      };
      clientCreate.billing = {
        billClient: client.billClient
      };
      client.process = {
        processing: true
      };
      return leanLawApi.createClient({
        body: clientCreate
      });
    }
    return $q.resolve(client.client);
  }
}]);